var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center pb-5 ml-5"},[_c('div',{staticClass:"connect-import-schema"})])
}]

export { render, staticRenderFns }